export default "__VITE_ASSET__B14JMU7L__"